import { NumberInput, Select, Stack, TextInput } from '@mantine/core'
import { useForm, zodResolver } from '@mantine/form'
import Form from 'common/Form'
import { workSchema } from 'types/schemas'
import { NewWork, UpdateWork, WorkType } from 'types/work'
import { orderPlaces, trimFormValues, workTypes } from 'utils'

type Props = {
  onSubmit: (values: NewWork) => void
  onCancel: () => void
  initialValues?: UpdateWork
  type: 'add' | 'update'
}

export default function WorkForm({ onSubmit, onCancel, type, initialValues }: Props) {
  const form = useForm<NewWork>({
    validate: zodResolver(workSchema),
    initialValues,
    transformValues: trimFormValues,
  })

  return (
    <Form
      onSubmit={onSubmit}
      form={form}
      onCancel={onCancel}
      submitText={type === 'add' ? 'Dodaj wykonaną pracę' : 'Edytuj wykonaną pracę'}
    >
      <Stack gap="xs">
        <Select
          label="Rodzaj pracy"
          description="Rodzaj wykonanej pracy"
          placeholder="Wybierz rodzaj pracy"
          data={workTypes.filter((type) => type.value !== WorkType.SEWING)}
          withAsterisk
          {...form.getInputProps('workType')}
        />
        <TextInput
          label="Numer zamówienia"
          description="Numer zamówienia, numer telefonu lub inny identyfikator"
          placeholder="123456"
          withAsterisk
          {...form.getInputProps('orderNumber')}
        />
        <NumberInput
          label="Ilość"
          description="Ilość wykonanej pracy w metrach"
          placeholder="10.65 m"
          allowNegative={false}
          allowDecimal
          decimalScale={2}
          fixedDecimalScale
          hideControls
          suffix=" m"
          decimalSeparator=","
          withAsterisk
          {...form.getInputProps('amount')}
        />
        <Select
          label="Miejsce"
          description="Miejsce na które trafiły produkty"
          placeholder="Wybierz miejsce"
          data={orderPlaces}
          withAsterisk
          {...form.getInputProps('place')}
        />
        <TextInput
          label="Uwagi"
          description="Dodatkowe informacje dotyczące zamówienia"
          placeholder="Pilne"
          {...form.getInputProps('comments')}
        />
      </Stack>
    </Form>
  )
}
